module.exports = __webpack_public_path__ + "img/credible-level3.ce746c2d.svg";